import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery/baseQueryWithReauth";
import { IPatientAppointments } from "../types/patients/IPatientAppointments.interface";
import { queryStringBuilder } from "@helperFunctions/api/queryStringBuilder";
import { PatientAppointments } from "../types/patients/PatientAppointments.interface";
import { IPatientUpcomingAppointments } from "../types/patients/IPatientUpcomingAppointments.interface";

export const patientsApi = createApi({
  reducerPath: "patientsApi",
  baseQuery: baseQueryWithReauth(`${import.meta.env.VITE_APP_API_HOST}`),
  endpoints: (builder) => ({
    getPatientAppointments: builder.query<
      IPatientAppointments,
      PatientAppointments
    >({
      query: ({ formData, id }) => {
        const queryParams = queryStringBuilder(formData).toString();
        return `/PatientAppointments?PatientId=${id}&${queryParams}`;
      },
    }),
    getUpcomingNotBrokenPatientAppointments: builder.query<
      IPatientAppointments,
      IPatientUpcomingAppointments
    >({
      query: ({ id, sinceDateInSeconds }) => {
        let route = `/patientAppointments/?FamilyScope=PatientOnly&PatientId=${id}&FilterCategory=UpcomingNotBroken`;
        if (sinceDateInSeconds) {
          route += `&SinceDate=${sinceDateInSeconds}`;
        }
        return route;
      },
    }),
  }),
});

export const {
  useGetPatientAppointmentsQuery,
  useGetUpcomingNotBrokenPatientAppointmentsQuery,
} = patientsApi;
